import React from "react";
import { Tooltip } from "@material-ui/core";
import { ValidationBadgeWrap } from "../styles";
import type { ValidationResult } from "../types";

interface Props {
	results: ValidationResult[];
}

export default function ValidationBadge({ results }: Props) {
	const errors = results.filter((r) => r.severity === "error");
	const warns = results.filter((r) => r.severity === "warn");

	if (errors.length === 0 && warns.length === 0) {
		return null;
	}

	const severity = errors.length > 0 ? "error" : "warn";
	const icon = errors.length > 0 ? "fa fa-times-circle" : "fa fa-exclamation-triangle";
	const title = [...errors, ...warns].map((r) => r.message).join("\n");

	return (
		<Tooltip
			title={<span style={{ whiteSpace: "pre-line" }}>{title}</span>}
			placement="top">
			<ValidationBadgeWrap severity={severity}>
				<i className={icon} />
			</ValidationBadgeWrap>
		</Tooltip>
	);
}
